import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateCredits, updateUser } from '../slices/authSlice'; 
import { useNavigate } from 'react-router-dom';
import useApiWithAuth from '../utils/useApiWithAuth';

const UserCredits = ({ reloadTrigger = 0 }) => {
    const dispatch = useDispatch();
    const credits = useSelector((state) => state.auth.user?.credits);
    const userId = useSelector((state) => state.auth.user?.id);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null); 
    const navigate = useNavigate();
    const { apiCall } = useApiWithAuth();

    // Fonction pour récupérer les crédits
    const fetchUpdatedCredits = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const response = await apiCall(`https://cvanalyzerback.osc-fr1.scalingo.io/api/users/${userId}/credits`);
            const data = await response.json();
            
            dispatch(updateCredits(data.credits));
            if (typeof data.hasPaid === 'boolean') {
                dispatch(updateUser({ hasPaid: data.hasPaid }));
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des crédits:', error);
            setError('Impossible de récupérer les crédits');
            
            // Si c'est une erreur d'authentification, rediriger vers login
            if (error.message.includes('Session expirée') || error.message.includes('401')) {
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    };

    // Charger les crédits lors de la première montée du composant
    useEffect(() => {
        if (userId) {
            fetchUpdatedCredits();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    // Recharger les crédits à chaque incrément (évite le booléen bloqué sur true)
    useEffect(() => {
        if (reloadTrigger > 0 && userId) {
            fetchUpdatedCredits();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadTrigger, userId]);
    

    if (loading) {
        return (
            <div className="flex items-center justify-center p-4">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                <span className="ml-2 text-sm text-gray-600">Chargement...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center p-4">
                <div className="text-red-500 text-sm mb-2">{error}</div>
                <button 
                    onClick={fetchUpdatedCredits}
                    className="text-blue-600 hover:text-blue-800 text-sm underline"
                >
                    Réessayer
                </button>
            </div>
        );
    }

    return (
        <div className="text-center">
            <div className="text-3xl font-bold text-green-600 mb-2">
                {credits || 0}
            </div>
            <div className="text-sm text-gray-600">
                crédits disponibles
            </div>
            <button 
                onClick={fetchUpdatedCredits}
                className="mt-3 text-blue-600 hover:text-blue-800 text-xs underline"
                title="Actualiser les crédits"
            >
                Actualiser
            </button>
        </div>
    );
};

export default UserCredits;
